import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from './pages/Homepage';
// import Dashboard from './pages/Dashboard';
import RequireAuth from './components/common/RequireAuth';
import Login from './pages/Login';
import Revenue from './pages/merchant/revenue/index';
import WorkspacesManager from './pages/merchant/workspaces-manager/index';
import WorkspacesManagerNew from './pages/merchant/workspaces-manager-new/index';
import SmartForecast from './pages/merchant/smart-forecast/index';
import Dashboard from './pages/Dashboard';
import Customer from './pages/merchant/customer/index';
import MerchantDashboard from './pages/merchant/dashboard/index';
import AdminCustomerManager from './pages/admin/customer-manager/index';
import Chatbot from './components/common/Chatbot';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Homepage />
            </RequireAuth>
          }
        >
          <Route path="revenue" element={<Revenue />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/workspaces" element={<WorkspacesManager />} />
          <Route path="/workspaces-new" element={<WorkspacesManagerNew />} />
          <Route path="/predict" element={<SmartForecast />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/merchant-dashboard" element={<MerchantDashboard />} />
          <Route path="/admin/customer" element={<AdminCustomerManager />} />
        </Route>
      </Routes>
      <Chatbot />
    </BrowserRouter>
  );
}
